<div class="flex flex-col items-center justify-center flex-1 p-5">
  <h1 class="mb-4" translate>label.forgotPassword</h1>

  <ng-container *ngIf="!isSent; else sent">
    <p-card class="w-full max-w-md">
      <form id="htmlForgotPasswordForm" action="" (submit)="submit($event)">
        <div class="mb-4">
          <p-floatlabel variant="on">
            <label for="email">{{ 'label.email' | translate }}</label>
            <input
              pInputText
              id="email"
              type="email"
              name="email"
              [(ngModel)]="email"
              autocomplete="email"
              class="w-full"
          /></p-floatlabel>
        </div>
        <div class="mt-5">
          <button class="w-full" (onClick)="submit($event)" pButton>
            {{ 'label.submit' | translate }}
          </button>
        </div>
      </form>
    </p-card>
  </ng-container>
  <ng-template #sent>
    <p-card class="w-full max-w-md">
      <p [innerHTML]="'label.forgotPasswordSentDescription' | translate"></p>
      <button class="w-full mt-5" routerLink="/login" pButton>
        {{ 'label.toLogin' | translate }}
      </button>
    </p-card>
  </ng-template>
</div>
